export const ORGANIZATIONS_ADMIN_TAGS = {
  ORGANIZATIONS_LIST_TAG: "OrganizationsList",
  ORGANIZATION_DETAILS_TAG: "OrganizationDetails",
};
